import { type DependencyList, useEffect, useRef } from "react";

export function useAsyncEffect(
  effect: () => Promise<void>,
  deps: DependencyList,
  destructor?: () => void,
) {
  const effectRef = useRef(effect);
  const destructorRef = useRef(destructor);

  useEffect(() => {
    effectRef.current = effect;
    destructorRef.current = destructor;
  });

  useEffect(() => {
    effectRef.current();
    return () => destructorRef.current?.();
  }, deps);
}
